import dayjs from 'dayjs';
import _ from 'lodash';

import { BCJointStatus, BCStatuses, UserMonthStatusEnum, UsersBCDay, UsersBCMonth } from 'api/TimeSheet/types';
import { DEFAULT_DATE_FORMAT } from 'helpers/constants/_common/timeFormats';

/** Returns UsersBCDay[] of calendar month, with correct BCStatus and with null ids. */
export const blankUsersDaysGenerator = (date: string): UsersBCDay[] => {
  const dayjsObj = dayjs(date);

  if (dayjsObj.format() === 'Invalid Date') return [] as UsersBCDay[];

  const daysInMonth = dayjsObj.daysInMonth();

  return _.range(daysInMonth)
    .map((e, i) => {
      const dayjsObjOfCurrentDate = dayjsObj.date(1 + i);
      const currentDay = dayjsObjOfCurrentDate.day();
      const holidaysDays = [ 0, 6 ];

      return {
        businessDayId: null,
        day: dayjsObjOfCurrentDate.format(DEFAULT_DATE_FORMAT),
        status: holidaysDays.includes(currentDay) ? BCStatuses.Holiday : BCStatuses.Regular,
        jointStatus: BCJointStatus.Basic,
        hours: 0,
      };
    }) as UsersBCDay[];
};

/** Returns UsersBCMonth[] of calendar month, with null Ids, needed for cases when getBusinessCalendar returns 404. */
export const blankUsersBCGenerator = (date: string): UsersBCMonth => {
  const fakeDateDayjs = dayjs(date);
  const fakeBCMonth: UsersBCMonth = {
    businessMonthId: null,
    year: fakeDateDayjs.year(),
    month: fakeDateDayjs.month() + 1,
    days: blankUsersDaysGenerator(fakeDateDayjs.format(DEFAULT_DATE_FORMAT)),
    startDay: fakeDateDayjs.date(1).format(DEFAULT_DATE_FORMAT),
    endDay: fakeDateDayjs.date(fakeDateDayjs.daysInMonth()).format(DEFAULT_DATE_FORMAT),
    userMonthStatus: UserMonthStatusEnum.Opened,
    modified: false,
  };

  return fakeBCMonth;
};
